module.exports = __webpack_public_path__ + "static/media/wish_V_cs.978d5626.png";